import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-donut-chart',
  templateUrl: './donut-chart.component.html',
  styleUrls: ['./donut-chart.component.scss']
})
export class DonutChartComponent implements OnInit {
  dataSource: {};
  constructor() { }

  ngOnInit() {
    // Preparing the chart data
    this.dataSource = {
      chart: {
        startingAngle: '310',
        showLegend: '1',
        defaultCenterLabel: '62% Male 65mn Reach | 38% Female 86mn Reach',
        centerLabel: '$label: $value',
        centerLabelBold: '1',
        showTooltip: '0',
        decimals: '0',
        theme: 'fusion',
        showLabels: '0',
        showValues: '0',
        pieRadius: '80%',
        doughnutRadius: '80%',
        numberSuffix: '%',
        paletteColors: '#428DFF, #005AA2',
        bgColor: '#fdfdfd'
      },
      data: [
        {
          label: 'Male',
          value: '62'
        },
        {
          label: 'Female',
          value: '38'
        }
      ]
    };
  }

}
